import { Grid } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { FieldConfiguration } from '../../../api/ConfigApi';
import { AuthData } from '../../../context/auth';
import { PolicyData, withPolicyContext } from '../../../context/policy';
import {
	FieldGroupCreateRequest,
	FieldGroupUpdateRequest,
	FieldValuesMap,
	PolicyCharacteristics,
} from '../../../types/policy';
import { isEmpty } from '../../../util/util';
import { StyledWrappedFields } from '../../common';
import FieldLabel from '../../fields/FieldLabel';
import FieldGroupChanges from './FieldGroupChanges';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
	policyCharacteristic: PolicyCharacteristics;
	changedFieldValues: FieldValuesMap;
	addedFieldGroups: FieldGroupCreateRequest[];
	removedFieldGroups: string[];
	updatedFieldGroups: FieldGroupUpdateRequest[];
	fieldConfigurations: FieldConfiguration[];
}

const useStyles = makeStyles((theme) => ({
	disabledInput: {
		'& .MuiInputBase-root.Mui-disabled': {
			color: 'rgba(0, 0, 0, 0.54)',
		},
	},
}));

// for review changes endorsement
const PolicyChanges = (props: Props) => {
	const classes = useStyles();
	const {
		policyCharacteristic,
		changedFieldValues,
		addedFieldGroups,
		removedFieldGroups,
		updatedFieldGroups,
		fieldConfigurations,
	} = props;

	if (
		isEmpty(changedFieldValues) &&
		!removedFieldGroups.length &&
		!addedFieldGroups.length &&
		!updatedFieldGroups.length
	) {
		return null;
	}

	if (!fieldConfigurations.length) {
		return null;
	}

	const renderField = (field: any, index: number) => {
		const value: any = changedFieldValues[field.name] || '';
		return (
			<FormControl>
				<FieldLabel
					id={`${field.name}-label-${index}`}
					required={!field.optional}
					title={field.title}
				/>
				<TextField
					className={classes.disabledInput}
					id={`${field.name}-${index}`}
					value={value}
					disabled
				/>
			</FormControl>
		);
	};

	const renderPolicyFieldChanges = () => {
		if (!changedFieldValues || _.isEmpty(changedFieldValues)) {
			return null;
		}
		return Object.keys(changedFieldValues).map(
			(fieldName: string, index: number) => {
				const fieldConfig = fieldConfigurations.find(
					(f) => f.name === fieldName,
				);

				const key1 = `${fieldName}-${index}`;

				return (
					<Grid item key={key1}>
						{fieldConfig.newline && <Break />}
						{renderField(fieldConfig, index)}
					</Grid>
				);
			},
		);
	};

	const hasUpdatedFields = !!changedFieldValues;
	const hasAddedFieldGroups = addedFieldGroups && addedFieldGroups.length;
	const hasUpdatedFieldGroups = updatedFieldGroups && updatedFieldGroups.length;
	const hasRemovedFieldGroups = removedFieldGroups && removedFieldGroups.length;
	if (
		!hasUpdatedFields &&
		!hasAddedFieldGroups &&
		!hasUpdatedFieldGroups &&
		!hasRemovedFieldGroups
	) {
		return null;
	}

	return (
		<>
			<StyledWrappedFields>
				<div style={{ marginTop: '10px ', marginBottom: '10px' }}>
					<Grid container spacing={1}>
						{renderPolicyFieldChanges()}
					</Grid>
				</div>
			</StyledWrappedFields>

			<FieldGroupChanges
				originalFieldGroups={policyCharacteristic.fieldGroupsByLocator}
				originalFieldValues={policyCharacteristic.fieldValues}
				addedFieldGroups={addedFieldGroups}
				removedFieldGroups={removedFieldGroups}
				updatedFieldGroups={updatedFieldGroups}
				fieldConfigurations={fieldConfigurations}
			/>
		</>
	);
};

const Break = styled.div`
	width: 100%;
	height: 0;
`;

export default withPolicyContext<Props>(PolicyChanges);
